<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <!-- Success Message -->
    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}

    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}

    </div>

    <!-- TITLE -->
    <!-- <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">

        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                News Management
            </h2>

            <p class="text-sm text-slate-500 mt-1">
                Configure website locales and translations.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">

            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add</span>

        </button>

    </div> -->

    <div
        class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
        <div>
            <div class="flex items-center gap-3">
                <h1 class="text-2xl font-bold text-slate-800">News Management</h1>
                <span
                    class="inline-flex items-center gap-1.5 px-3 py-1 bg-amber-50 text-amber-700 text-xs font-bold rounded-full border border-amber-200">
                    <span class="material-symbols-outlined text-sm">warning</span>
                    News is currently Live
                </span>
            </div>
            <p class="text-slate-500 text-sm mt-1">Organize and manage your website's news, events, and announcements
                etc .
            </p>
        </div>
        <div class="flex items-center gap-3 w-full md:w-auto">
            <button (click)="toggleFilters()"
                class="flex-1 md:flex-none flex items-center justify-center gap-2 px-4 py-2.5 border border-slate-300 text-slate-700 font-bold rounded-lg hover:bg-slate-50 transition-all text-sm">
                <span class="material-symbols-outlined text-xl">filter_alt</span>
                <span>{{ isFilterVisible ? 'Hide Filters' : 'Show Filters' }}</span>
            </button>

            <button (click)="addNew()"
                class="flex-1 md:flex-none flex items-center justify-center gap-2 px-6 py-2.5 bg-primary text-white font-bold rounded-lg shadow-md hover:shadow-lg hover:bg-[#003d7e] transition-all text-sm">
                <span class="material-symbols-outlined text-xl">add_circle</span>
                <span>Add News Item</span>
            </button>
        </div>
    </div>

    <!-- <div class="bg-white p-4 rounded-xl border border-slate-200 mb-6 flex flex-wrap gap-4 items-center shadow-sm">
            <div class="flex-grow max-w-md relative">
                <span
                    class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">filter_list</span>
                <input
                    class="w-full pl-10 pr-4 py-2 border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary"
                    placeholder="Filter by title or URL..." type="text" />
            </div>
            <select class="border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary py-2 px-4">
                <option>All Levels</option>
                <option>Main Menu</option>
                <option>Sub-menu</option>
            </select>
            <select class="border-slate-200 rounded-lg text-sm focus:ring-primary focus:border-primary py-2 px-4">
                <option>All Status</option>
                <option>Visible</option>
                <option>Hidden</option>
            </select>
            <button class="ml-auto text-slate-500 hover:text-primary flex items-center gap-1 text-sm font-medium">
                <span class="material-symbols-outlined text-lg">refresh</span>
                Reset Filters
            </button>
        </div> -->


    <div class="flex border-b border-slate-200 mb-4 gap-6">

        <!-- Dynamic Languages -->
        <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
            [class.text-primary]="activeTab === lang.code" [class.border-primary]="activeTab === lang.code">

            <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">

            {{ lang.name }} ({{ getLanguageCount(lang.code) }})

        </button>

    </div>

    <div *ngIf="isFilterVisible" class="mb-4 bg-white rounded-xl border border-slate-200 p-4 shadow-sm">
        <div class="space-y-3">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Title</label>
                    <input type="text" [(ngModel)]="searchText" (keyup.enter)="onFilterChange()"
                        placeholder="Search title"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>

                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Category</label>
                    <select [(ngModel)]="filterCategoryId" (ngModelChange)="onFilterChange()"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <option [ngValue]="null">All categories</option>
                        <option *ngFor="let c of mergedNewsCategories" [ngValue]="c.newsCategoryId">
                            {{ c.newsCategoryId }} - {{ c.kh }} - {{ c.en }}
                        </option>
                    </select>
                </div>

                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Year</label>
                    <input type="number" [(ngModel)]="filterYear" (ngModelChange)="onFilterChange()"
                        placeholder="All years"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>

                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Publish Date</label>
                    <input type="date" [(ngModel)]="filterPublishDate" (ngModelChange)="onFilterChange()"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">News Position</label>
                    <select [(ngModel)]="filterNewsPosition" (ngModelChange)="onFilterChange()"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <option value="">All positions</option>
                        <option value="FrontMain">Front Main</option>
                        <option value="Front">Front</option>
                        <option value="No">No</option>
                        <option value="Mission">Mission</option>
                        <option value="Vision">Vision</option>
                        <option value="Message">Message</option>
                        <option value="History">History</option>
                    </select>
                </div>

                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Status</label>
                    <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <option value="">All statuses</option>
                        <option value="Draft">Draft</option>
                        <option value="Published">Published</option>
                        <option value="Archived">Archived</option>
                    </select>
                </div>

                <div>
                    <label class="block text-xs font-semibold text-slate-500 mb-1">Location</label>
                    <select [(ngModel)]="filterLocationId" (ngModelChange)="onFilterChange()"
                        class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <option [ngValue]="null">All locations</option>
                        <option *ngFor="let location of locationOptions" [ngValue]="location.id">
                            {{ location.name }}
                        </option>
                    </select>
                </div>

                <div class="flex gap-2">
                    <button (click)="onFilterChange()"
                        class="flex-1 inline-flex items-center justify-center gap-2 bg-primary text-white rounded-md px-3.5 py-2.5 text-sm font-semibold hover:bg-primary/90 transition">
                        <span class="material-symbols-outlined text-[18px]">search</span>
                        Search
                    </button>
                    <button (click)="resetFilters()"
                        class="inline-flex items-center justify-center border border-slate-300 text-slate-600 rounded-md px-3.5 py-2.5 text-sm font-semibold hover:bg-slate-50 transition">
                        <span class="material-symbols-outlined text-[18px]">restart_alt</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">

        <div class="overflow-x-auto">

            <table class="w-full text-left border-collapse">

                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">

                        <!-- <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Destination Category
                        </th> -->

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Category
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Title
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Summary
                        </th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            News Position
                        </th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Publish Date
                        </th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase" style="width:150px">
                            Status
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right"
                            style="width:150px">
                            Actions
                        </th>

                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">

                    <tr *ngFor="let obj of pagedNews" class="hover:bg-slate-50 transition-colors">


                        <!-- Destination -->
                        <td class="px-3.5 py-2.5 col-width">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.categoryName }}
                            </span>
                        </td>

                        <!-- Link -->
                        <td class="px-3.5 py-2.5 col-width">
                            <span class="block px-2 py-1 text-xs rounded bg-slate-100 text-slate-600 w-full"
                                [innerHTML]="getSafeContent(obj.title)">
                            </span>
                        </td>


                        <!-- Language -->
                        <td class="px-3.5 py-2.5 col-width">
                            <span class="block px-2 py-1 text-xs rounded bg-slate-100 text-slate-600 w-full"
                                [innerHTML]="getSafeContent(obj.summary)">
                            </span>
                        </td>

                        <td class="px-3.5 py-2.5 col-width">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.newsPosition }}
                            </span>
                        </td>

                        <td class="px-3.5 py-2.5 col-width">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.publishDate | date:'yyyy-MM-dd HH:mm:ss':'UTC+7' }}
                            </span>
                        </td>

                        <!-- Enable -->
                        <td class="px-3.5 py-2.5 font-semibold text-slate-100 col-width">
                            <div class="flex cursor-pointer">
                                <span class="relative inline-block w-10 h-5 rounded-full transition-colors duration-300"
                                    [ngClass]="obj.status === 'Published' ? 'bg-green-500' : 'bg-gray-300'">
                                    <span
                                        class="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-300"
                                        [ngStyle]="{'transform': obj.status === 'Published' ? 'translateX(100%)' : 'translateX(0)'}">
                                    </span>
                                </span>

                                <span class="px-2 py-1 text-xs text-slate-600">
                                    {{ obj.status }}
                                </span>
                            </div>
                        </td>

                        <!-- Actions -->
                        <td class="px-3.5 py-2.5 text-right col-width">
                            <div class="flex justify-end gap-2">
                                <button class="p-1.5 text-slate-400 hover:text-primary"
                                    (click)="viewData(obj.newsId,'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>

                                <button class="p-1.5 text-slate-400 hover:text-red-500"
                                    (click)="viewData(obj.newsId,'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>

                    </tr>

                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="8">
                            <div class="flex justify-center mt-6 mb-6 gap-2">
                                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                                    (click)="changePage(i + 1)"
                                    [ngClass]="currentPage === (i+1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                                    class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                                    {{ i + 1 }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tfoot>

            </table>

        </div>

    </div>

</main>


<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">

    <!-- Modal Container -->
    <div class="bg-white w-[1024px] max-h-[90vh] rounded-xl shadow-xl flex flex-col">

        <!-- Header -->
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50 flex-shrink-0">
            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">admin_panel_settings</span>
                    Add News
                </h3>
                <p class="text-sm text-slate-500 mt-0.5">
                    Define and configure a news for the portal.
                </p>
            </div>
            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>
        </div>

        <!-- Body -->
        <div class="p-5 overflow-y-auto flex-1 space-y-6">

            <div class="mt-4">
                <div class="flex items-center gap-4">


                    <label class="w-[150px] text-sm font-semibold text-gray-700">Category</label>
                    <select [(ngModel)]="NewsCategoryId" name="NewsCategoryId" style="width: 100%;"
                        class="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <option [ngValue]="null">Select Category</option>
                        <option *ngFor="let c of mergedNewsCategories" [ngValue]="c.newsCategoryId">
                            {{ c.newsCategoryId }} - {{ c.kh }} - {{ c.en }}
                        </option>
                    </select>
                </div>
            </div>

            <!-- Two Column Form Fields -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Left Column -->
                <div class="space-y-4">
                    <!-- Slug -->
                    <div class="flex items-center gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700">Slug</label>
                        <input type="text" [(ngModel)]="Slug" name="Slug" required maxlength="100"
                            placeholder="Enter Slug"
                            class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>

                    <!-- News Position -->
                    <div class="flex items-center gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700">News Position</label>
                        <select [(ngModel)]="newsPosition" name="newsPosition"
                            class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option value="">-- Select Position --</option>
                            <option value="FrontMain">Front Main</option>
                            <option value="Front">Front</option>
                            <option value="No">No</option>
                            <option value="Mission">Mission</option>
                            <option value="Vision">Vision</option>
                            <option value="Message">Message</option>
                            <option value="History">History</option>
                        </select>
                    </div>

                </div>

                <!-- Right Column -->
                <div class="space-y-4">

                    <!-- Publish Date -->
                    <div class="flex items-center gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700">Publish Date</label>
                        <input type="date" [(ngModel)]="PublishDate" name="PublishDate" required
                            class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>

                    <!-- Image Upload -->
                    <div class="flex items-start gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700 pt-2">Images</label>
                        <div class="flex-1 space-y-2">
                            <input type="file" (change)="onFileSelected($event)" name="images" accept="image/*"
                                multiple
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <p *ngIf="existingImageUrls.length && !images.length" class="text-xs text-slate-500">
                                {{ existingImageUrls.length }} current image{{ existingImageUrls.length > 1 ? 's' : '' }}. Select new files to replace them.
                            </p>
                            <p *ngIf="images.length" class="text-xs text-slate-500">
                                {{ images.length }} new image{{ images.length > 1 ? 's' : '' }} selected. First image will be the cover.
                            </p>
                        </div>
                    </div>

                    <!-- PDF Upload -->
                    <div class="flex items-start gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700 pt-2">PDF</label>
                        <div class="flex-1 space-y-2">
                            <input type="file" (change)="onPdfSelected($event)" name="pdf" accept="application/pdf"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <p *ngIf="existingPdfUrl && !pdfFile" class="text-xs text-slate-500">
                                Current PDF attached.
                                <a [href]="existingPdfUrl" target="_blank" class="text-primary hover:underline">Open PDF</a>
                            </p>
                            <p *ngIf="pdfFile" class="text-xs text-slate-500">
                                {{ pdfFile.name }} selected.
                            </p>
                        </div>
                    </div>

                    <!-- Status -->


                </div>
                <div class="space-y-4">

                    <div class="flex items-center gap-4">
                        <label class="w-[150px] text-sm font-semibold text-gray-700">Status</label>
                        <select [(ngModel)]="status" name="status"
                            class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                            <option value="">-- Select Status --</option>
                            <option value="Draft">Draft</option>
                            <option value="Published">Published</option>
                            <option value="Archived">Archived</option>
                        </select>
                    </div>

                </div>

            </div>

            <!-- Locations Row -->
            <div class="mt-4">
                <div class="flex items-center gap-4">
                    <label class="w-[150px] text-sm font-semibold text-gray-700">Locations</label>
                    <ng-select [items]="locationOptions" bindLabel="name" bindValue="id" [multiple]="true"
                        placeholder="Select locations" [(ngModel)]="locationIds" (change)="onLocationChange()"
                        class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        style="width: 100%;">
                    </ng-select>
                </div>
            </div>

            <div class="mt-4">
                <div class="flex items-center gap-4">
                    <label class="w-[150px] text-sm font-semibold text-gray-700">Related News</label>
                    <ng-select [items]="relatedNewsOptions" bindLabel="name" bindValue="id" [multiple]="true"
                        placeholder="Select related news" [(ngModel)]="relatedNewsIds" (change)="onRelatedNewsChange()"
                        class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        style="width: 100%;">
                    </ng-select>
                </div>
            </div>

            <!-- Language Tabs -->
            <div class="flex border-b border-gray-200 gap-6 mt-6">
                <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
                    class="pb-3 px-6 text-sm font-semibold border-b-2 flex items-center gap-2 transition-all"
                    [class.text-primary]="activeTabPopup === lang.languageId"
                    [class.border-primary]="activeTabPopup === lang.languageId">
                    <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-gray-200" />
                    {{ lang.name }}
                </button>
            </div>

            <!-- Form Fields -->
            <form enctype="multipart/form-data" class="space-y-4 mt-4">

                <!-- Khmer Tab -->
                <div *ngIf="activeTabPopup === 1" class="space-y-4">
                    <label class="block text-sm font-semibold text-gray-700">Title</label>
                    <input type="text" [(ngModel)]="TitleKh" name="TitleKh" required placeholder="Enter title in Khmer"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block text-sm font-semibold text-gray-700">Summary</label>
                    <quill-editor class="w-full" [(ngModel)]="SummaryKh" name="SummaryKh" [styles]="{height: '120px'}"
                        placeholder="Enter summary in Khmer"
                        [modules]="{ toolbar: [['bold','italic'],['link'],[{ list:'bullet' }]] }">
                    </quill-editor>

                    <label class="block text-sm font-semibold text-gray-700 mt-4">Content</label>
                    <quill-editor class="w-full" [(ngModel)]="ContentKh" name="ContentKh" [styles]="{height: '200px'}"
                        placeholder="Enter content in Khmer"
                        [modules]="{ toolbar: [['bold','italic','underline'],[{header:[1,2,3,false]}],[{list:'ordered'},{list:'bullet'}],['link']] }">
                    </quill-editor>
                </div>

                <!-- English Tab -->
                <div *ngIf="activeTabPopup === 2" class="space-y-4">
                    <label class="block text-sm font-semibold text-gray-700">Title</label>
                    <input type="text" [(ngModel)]="TitleEn" name="TitleEn" required
                        placeholder="Enter title in English"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block text-sm font-semibold text-gray-700">Summary</label>
                    <quill-editor class="w-full" [(ngModel)]="SummaryEn" name="SummaryEn" [styles]="{height: '120px'}"
                        placeholder="Enter summary in English"
                        [modules]="{ toolbar: [['bold','italic'],['link'],[{ list:'bullet' }]] }">
                    </quill-editor>

                    <label class="block text-sm font-semibold text-gray-700 mt-4">Content</label>
                    <quill-editor class="w-full" [(ngModel)]="ContentEn" name="ContentEn" [styles]="{height: '200px'}"
                        placeholder="Enter content in English" format="html"
                        [modules]="{ toolbar: [['bold','italic','underline'],[{header:[1,2,3,false]}],[{list:'ordered'},{list:'bullet'}],['link']] }">
                    </quill-editor>
                </div>

            </form>

        </div>

        <!-- Footer -->
        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200 flex-shrink-0">
            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>
            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>
            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>
        </div>

    </div>
</div>
